import React from 'react';
import { Text } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';

const items = [
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_1.png'),
    //   width: 1250,
    //   height: 1679,
    // },
    title: "Let’s Start a Project",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>You can create a project as a contractor (vendor) or a homeowner (buyer).</Text>,
    ],
    sections: [
      {
        title: "As a contractor, you have two (2) options:",
        items: [
          {
            name: "Create the project and invite your customer",
            text: null,
            note: null,
          },
          {
            name: "Create the project and save it for later",
            text: "Begin putting the project together, over time, and when you're ready, invite your customer to join.",
            note: null,
          }
        ],
        footer: [
          // "NO DEPOSITS OR PREPAYMENTS - You shouldn't ask your customer for a deposit or prepayment. You should create milestones where work is completed and money should be released to you. The general rule is that you should receive payment valued at 90% of the work completed or when material is delivered on-site, up to the final payment. On smaller jobs you might have just one (1) milestone payment such as the final payment - paid on completion of the project. For larger jobs you may have many milestones as work progresses and is completed. Your customer will fund the entire project and deposit the money with Renovation Trust - you know the money is there for you.",
          // "FEE STRUCTURE - You determine the fee structure. The default structure is 50/50 - shared equally between you and your customer. You can choose to pay all of the fees, none of the fees, or leave it with the default. It CANNOT be changed after your customer joins the project.",
          // "NOTE – You can use Renovation Trust with your sub-trades or if you are a sub-trade",
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.lightText, CS.boldText]}>NO DEPOSITS OR PREPAYMENTS</Text> - You shouldn't ask your customer for a deposit or prepayment. You should create milestones where work is completed and money should be released to you. The general rule is that you should receive payment valued at 90% of the work completed or when material is delivered on-site, up to the final payment. On smaller jobs you might have just one (1) milestone payment such as the final payment - paid on completion of the project. For larger jobs you may have many milestones as work progresses and is completed. Your customer will fund the entire project and deposit the money with Renovation Trust - you know the money is there for you.</Text>,
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.lightText, CS.boldText]}>FEE STRUCTURE</Text> - You determine the fee structure. The default structure is 50/50 - shared equally between you and your customer. You can choose to pay all of the fees, none of the fees, or leave it with the default. It CANNOT be changed after your customer joins the project.</Text>,
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}><Text style={[CS.lightText, CS.boldText]}>NOTE</Text> - You can use Renovation Trust with your sub-trades or if you are a sub-trade</Text>,
        ],
      },
    ],
    mustHave: null,
    need: null,
  },
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_2.png'),
    //   width: 1250,
    //   height: 1679,
    // },
    title: "Create the Project and Invite Your Customer",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If you have your customer's email address or cell phone number, and have agreed to a price, quote or contract you are ready to create your project.</Text>,
    ],
    sections: [],
    // mustHave: {
    //   items: [
    //     "A client",
    //     "A quote or contract you have both agreed to",
    //   ],
    //   description: [
    //     "If you have your client’s email address or cell phone number and have you have agreed to a price or have done a quote or contract you are good to Create your Project.",
    //     "NO Deposits or Prepayments! You are not to ask your client for any deposit or prepayment. You are to create milestones and milestone payments where you get paid as work is done. The general rule is you should receive payment valued at 90% of work completed or material on site, up to the final payment. On smaller jobs you can have just 1 milestone payment such as the final payment, paid on completion of the Project. For larger jobs you may have many milestone payments as work progresses and gets completed. Your client will fund the entire Project and deposit the money with renovation Trust, so you know the money is there for you as the work is completed.",
    //     "Choose the FEE STRUCTURE - As the contractor you choose the fee structure. The Renovation Trust fee structure is set at default 50/50 shared equally between you and your client as Renovation Trust protects both of you equally. It can NOT be changed later. You can choose to pay all the fees for both you and your client or you can choose not to pay any of Renovation Trust fees and make your client pay all the fees.",
    //   ]
    // },
    mustHave: null,
    need: {
      items: [
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Project Name</Text> - Example: Kelly's Kitchen Renovation</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Location of Project</Text> - address where the project will take place</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Customer's Name</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Customer's Email and/or Cell Phone Number</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Quote or Contract</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Scope of Work</Text> - the more detail the better</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Milestones and Payments</Text> - when you want funds released to you based on work completed or material on-site</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Drawings, Blueprints and Photos</Text></Text>,
      ],
      // description: [
      //   "Reminder – Milestone payments should be roughly 90% of the value of the work completed or materials on site up until the final payment. Do not ask for a deposit or any prepayment.",
      //   "Note: When creating your Project, the default Renovation Trust fee split is 50/50 with your client. You may change this if you like.",
      // ]
      description: []
    },
    source: 'https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/creatingAProject.mp4',
    youtube: 'wdiwWQSCtzo',
    button: 'Create My Project',
    goTo: '/project/new',
  },
  {
    // image: {
    //   source: require('../../../assets/img/my_first_project_4.png'),
    //   width: 1220,
    //   height: 1446,
    // },
    title: "Create A Project And Save It For Later",
    description: [
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Creating a project, without inviting a customer, allows you to spend the time necessary to make sure it's accurate and complete. This is especially valuable for large projects you need more time to put together.</Text>,
      <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>You can also add Inspirational Photos for your customer to visualize what the project could look like on completion, or materials you recommend they use.</Text>,
    ],
    sections: [],
    // mustHave: {
    //   items: [
    //     "A client who wants you to complete a Project for them",
    //   ],
    //   description: [
    //     "You can create a Project for a client and allows you to save it for a later date, allowing you to put it together over time. Great for large Projects you need more time to put together.",
    //     "You can add Inspirational Photos for your client to see or what the Project on completion can look like, materials you may want to use etc. ",
    //   ]
    // },
    mustHave: null,
    need: {
      items: [
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Project Name</Text> - example: My Kitchen Renovation</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Location of Project</Text> - address where the project will take place</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Scope of Work</Text> - the more detail the better</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Drawings, Blueprints and Photos</Text></Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}><Text style={[CS.lightText, CS.boldText]}>Inspirational Photos</Text> - ideas of how it may turn out</Text>,
      ],
      description: [
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Take as much time as you like, just make sure you save your changes every time.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>When you have included everything, invite to your customer to join and accept the project.</Text>,
      ]
    },
    source: 'https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/creatingAProject.mp4',
    youtube: 'wdiwWQSCtzo',
    button: 'Create my project',
    goTo: '/project/new',
  },
];

export default items;